import { useEffect } from 'react';
import { WOW } from 'wowjs';
import '../styles/animate.css';
import LandingFooter from './LandingFooter';
import LandingHeader from './LandingHeader';
import ScrollTop from './ScrollTop';
import VideoPopup from '../components/VideoPopup';
import { preventEmptyAnchor } from '../utils/dom';

const LandingLayout = ({ children, isAuthenticated, onLogin, onLogout, onRegister, onDashboard }) => {
    useEffect(() => {
        preventEmptyAnchor();
        if (typeof window !== 'undefined') {
            const wow = new WOW({
                live: false, // Set to false if you don't want it to watch for DOM changes
            });
            wow.init();
        }
    }, []);

    return (
        <div id="page" className="page">
            <LandingHeader
                isAuthenticated={isAuthenticated}
                onLogin={onLogin}
                onLogout={onLogout}
                onRegister={onRegister}
                onDashboard={onDashboard}
            />
            {children}
            <LandingFooter />
            <ScrollTop />
            <VideoPopup />
        </div>
    );
};

export default LandingLayout;
